import React from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';

import './style.css';

const ProjectInput = ({ project, handleMarkProjectCompleted, isChanged }) => {

    console.log('isChanged:', isChanged);
    return (
        <div key={project.project_id} className="form-project-card">
            <div className="project-image-container">
                <img
                    src={CreateCloudfrontUrl(project.project_image)}
                    alt={project.project_name}
                    className="form-project-image"
                />
            </div>
            <div className="form-project-card-details">

                <h3 className="update-module-project-name text-align-center">{project.project_name}</h3>
                <button
                    className={`mark-completed-button box-shadow-standard ${isChanged ? 'is-completed' : ''}`}
                    onClick={() => handleMarkProjectCompleted(project)}
                >
                    {isChanged ? 'Mark Incomplete' : 'Mark Completed'}
                </button>
            </div>
        </div>
    )
};

export default ProjectInput;